import React from "react"
import { AosWrapper } from "../../molecules/AosWrapper"
import { animationProperties } from "../../../utils"
import { ImagesContainer, LargeScreenImages, SmallScreenImages } from "./styles"

const TechImages = () => {
  return (
    <AosWrapper
      animatePreScroll={true}
      animateIn={"animate__fadeInUpBig"}
      duration={animationProperties.duration + 0.2}
      delay={animationProperties.delay + 0.2}
    >
      <ImagesContainer>
        <LargeScreenImages>
          <div className={"column"}>
            <img src={"/assets/imgs/techm3.png"} />
            <img src={"/assets/imgs/tech4.png"} />
            <img src={"/assets/imgs/tech3.png"} />
          </div>
          <div className={"column"}>
            <img src={"/assets/imgs/tech2.png"} id={"long-img"} />
            <img src={"/assets/imgs/techm2.png"} />
          </div>
        </LargeScreenImages>
        <SmallScreenImages>
          <div className={"row"}>
            <img src={"/assets/imgs/techm5.svg"} className={"grid-item"} />
            <img src={"/assets/imgs/techm3.svg"} className={"grid-item"} />
            <img src={"/assets/imgs/techm4.svg"} className={"grid-item"} />
            <img src={"/assets/imgs/techm1.svg"} className={"grid-item"} />
            <img src={"/assets/imgs/techm2.svg"} className={"grid-item"} />
          </div>
        </SmallScreenImages>
      </ImagesContainer>
    </AosWrapper>
  )
}

export default TechImages
